import { Badge } from "@/components/ui/badge";
import { useState } from "react";

const SideRailSkillsList = ({ skills }: { skills: string[] }) => {
  const [isExpanded, setIsExpanded] = useState(false);
  return (
    <div className="bg-putty-100 border rounded-[8px] shadow w-full max-w-md mx-auto bg-white">
      <h2 className="text-lg font-semibold py-2 px-4 my-0">
        Grow these skills
      </h2>
      <div className="p-4 pt-1 flex flex-row gap-2 flex-wrap">
        {skills.map((skill, i) => (
          <Badge
            key={skill ?? i}
            className={`whitespace-nowrap bg-putty-200
               border-putty-400 text-primary-500
               !rounded !shadow-none ${!isExpanded && i > 2 ? "hidden" : ""} `}
          >
            <p className="m-0 text-xs font-normal">{skill}</p>
          </Badge>
        ))}
      </div>
      <div className="px-4 pb-4">
        {skills.length > 3 && (
          <div className={`flex ${skills.length <= 3 ? "hidden" : ""}`}>
            <span
              className="underline cursor-pointer"
              onClick={() => setIsExpanded(!isExpanded)}
            >
              {!isExpanded ? "Show More" : "Show Less"}
            </span>
          </div>
        )}
      </div>
    </div>
  );
};

export default SideRailSkillsList;
